import { render, staticRenderFns } from "./UserChip.vue?vue&type=template&id=79dad502&scoped=true"
import script from "./UserChip.vue?vue&type=script&lang=js"
export * from "./UserChip.vue?vue&type=script&lang=js"
import style0 from "./UserChip.vue?vue&type=style&index=0&id=79dad502&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79dad502",
  null
  
)

export default component.exports